import { NetworkStatus, useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_ATTACHABLE_AWS_INTEGRATIONS_FOR_INTENT_PROJECT } from "./gql";

const useAttachableAwsIntegrations = (spaceId: string) => {
  const { data, refetch, error, networkStatus } = useQuery(
    GET_ATTACHABLE_AWS_INTEGRATIONS_FOR_INTENT_PROJECT,
    {
      variables: {
        id: spaceId,
      },
      skip: !spaceId,
    }
  );

  const attachableAwsIntegrations = useMemo(() => {
    return (data?.attachableAwsIntegrationsInSpace || [])
      .filter((integration) => !integration.legacy)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [data?.attachableAwsIntegrationsInSpace]);

  const hasData = !!data?.attachableAwsIntegrationsInSpace;
  const initialLoading =
    attachableAwsIntegrations.length === 0 && networkStatus === NetworkStatus.loading;

  return {
    attachableAwsIntegrations,
    initialLoading,
    refetch,
    hasData,
    error,
  };
};

export default useAttachableAwsIntegrations;
